import React from 'react';
import { MathFair2025 } from '../views';

const AccountGeneralPage = () => {
  return <MathFair2025/>;
};

export default AccountGeneralPage;